import {IServicePaymentOption, ISectionState} from "shared-types/index";

export interface IWidgetSettings {
  maximumPeopleMessage: string;
  dayClosedMessage: string;
  noTablesAvailableMessage: string;
  timeNoLongerAvailableMessage: string;
  showTimeNotAvailable: boolean;
  timeNotAvailableMessage: string;
  maxPeoplePerBooking: number;
  canCustomersChooseSection: boolean;
  termsAndConditionsMessage: string;
  publicTermsAndConditionsMessage?: string;
  preAuthorisationMessage: string;
  bookingCancellationWindow: string; // number as string
  preAuthReleasingWindow?: string;
  theme: unknown;
  font?: string;
  accentColour: unknown;
  button: unknown;
  allowOnlineBookings: boolean;
  onlineBookingsOffMessage: string;
  minMinutesBeforeServiceBooking: number;
  maxDaysInFutureBooking: number;
  tooFarInAdvanceMessage: string;
  disableEditingTimeWindow: number;
  finalWidgetScreenMessage: string;
  minMinutesBeforeBooking: number;
}

export interface IEwayInfo {
  acceptVisa: boolean;
  acceptMasterCard: boolean;
  acceptAmericanExpress: boolean;
  acceptDiners: boolean;
  acceptJcb: boolean;
  clientSideEncryptionKey?: string;
  paymentProvider: paymentProviderType; // will get set to paymentProviderType.eway in AccountService -> getPaymentSettings
}

export interface IStripeInfo {
  publishableKey: string;
  paymentProvider: paymentProviderType; // will get set to paymentProviderType.stripe in AccountService -> getPaymentSettings
  stripe3DEnabled: boolean;
}


export enum paymentProviderType {
  eway = 'eway',
  stripe = 'stripe'
}

/**
 * Annoyingly this is uppercase first letter when coming from IOwnedVenue.
 * Gets forced to lowercase in AccountService -> getPaymentSettings
 */
export enum paymentProviderTypeUppercase {
  Eway = 'Eway',
  Stripe = 'Stripe'
}

export interface IPaymentSettings {
  paymentProvider: paymentProviderTypeUppercase;
  eway: IEwayInfo;
  stripe: IStripeInfo;
  preAuthReleasingWindow: number;
}

export interface IAnalyticsItem {
  apiKey: string;
}

export interface IAnalyticsInfo {
  facebook: IAnalyticsItem;
  google: IAnalyticsItem;
}

// very similar to IVenue, but not identical
export interface IOwnedVenue {
  id: number;
  name: string;
  country: string;
  address: string;
  suburb: string;
  postcode: string;
  state: string;
  phone: string;
  // city: string; // @toDo check this actually exists on ownedVenue. severity: high
  url: string;
  active: boolean;
  logoUrl: string;
  alternatePhone: string;
  contactEmail: string;
  widgetSettings: IWidgetSettings;
  timeZoneId: string;
  currency: string; // USD, AUD, GBP, etc
  paymentSettings: IPaymentSettings;
  canCustomersCancelBookings: boolean;
  canCustomersEditBookings: boolean;
  canCancelBookingBySms: boolean;
  canEditBookingBySms: boolean;
  analytics: IAnalyticsInfo;
}

export interface IScheduleParams {
  date: string; // YYYY-M-D
  numofpeople: number;
  bookingId?: string;
}


export interface ISimpleBookingOption {
  description: string;
  id: string; // "menuoption_UAQAZETMPS9T7_1573535792474"
  label: string;
  link: string;
  name: string;
  price: number;
  provider: string; // "Nbi"
  tag: string; // "tag_birthday"
  paymentType: servicePaymentType;
  paymentTypeOverride?: IPaymentTypeOverride
}

export interface IPaymentTypeOverride {
  paymentType: servicePaymentType; // for when child booking options dictate the payment type (on noPayment parents)
  hasError: boolean;
}

export interface IPaymentType {
  amount: number, // 132.5,
  paymentTypeName: servicePaymentType // "FullPayment"
}
//
// export interface IServicePaymentOption extends ISimpleBookingOption {
//   childMenuOptionIds?: string[];
//   explicitChildMenuOptionIds?: string[];
// }

export interface IMenuOptionsResponse {
  statusText: string; // OK
  status: number; // 200
  data: ISimpleBookingOption[];
}


export interface IServicePaymentDetails {
  hasPromotion: boolean;
  maxPeoplePerBookingOverride: number;
  options: IServicePaymentOption[];
  optionsFrom: unknown;
  optionsTo: unknown;
  paymentType: servicePaymentType;
  peopleRequired: number;
  price: number; // dollars
  singleMenuPerBooking: boolean;
  optionsUpsell?: IServicePaymentOption[];
  upsellHeading?: string;
  upsellDescription?: string;
}

export interface IScheduleTime {
  expired: boolean;
  name: string; // "6:00am"
  sections: ISectionState[];
  time: string; // "2019-11-14T06:00:00"
}

export enum servicePaymentType {
  fullPayment = "FullPayment",
  noPayment = "NoPayment",
  deposit = "Deposit",
  preAuth = "PreAuth",
  functionPayment = "FunctionPayment",
}

export interface ISectionOrder {
  id: string; // "section_GIYOEZ9CC963K"
  name: string; // "Main Room"
  order: number; // order in list compared with other sections
}
